import { InputGroup, Select, PrimaryButton } from "#common";
import { useState } from "react";
function MedicalRecords({ animal }) {
  return (
    <div>
      <CreateMedicalRecord animal={animal} />
      <MedicalHistory records={animal.medicalRecords} />
    </div>
  );
}
function CreateMedicalRecord({ animal }) {
  const [state, setState] = useState({
    animalId: animal.animalId,
    recordType: 0,
    recordDate: `${new Date().getFullYear()}-${new Date().getMonth()}`,
    notes: "",
  });
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    console.log(state);
  };
  const handleSubmit = () => {
    console.log(state);
  };
  return (
    <div className="flex items-center gap-2 py-2 px-4 shadow-sm bg-gray-100 mt-2">
      <div>Create Record</div>
      <Select
        value={state.recordType}
        name="recordType"
        onChange={handleChange}
        options={RecordTypes}
      />
      <InputGroup
        value={state.recordDate}
        name="recordDate"
        onChange={handleChange}
        type="date"
      />
      <InputGroup
        name="notes"
        value={state.notes}
        onChange={handleChange}
        placeholder="notes..."
      />
      <PrimaryButton onClick={handleSubmit} className="mt-1.5">
        Add
      </PrimaryButton>
    </div>
  );
}

function MedicalHistory({ records }) {
  return (
    <div className="flex flex-col gap-4 mt-4">
      {records.map((x) => (
        <div
          key={`medical-record-${x.medicalRecordId}`}
          className="shadow-sm rounded-md flex gap-4 p-2 items-center"
        >
          <div className="">{x.medicalRecordId}</div>
          <div>
            <div className="flex items-center gap-2">
              <div className="text-lg font-semibold">
                {RecordTypeFromId(x.recordType)}
              </div>
              <div>
                {x.recordDate ? (
                  new Date(x.recordDate).toLocaleDateString()
                ) : (
                  <span
                    className="text-yellow-500 hover:text-yellow-600"
                    title="Record date is not supplied, this is the date created in the database"
                  >
                    {new Date(x.createdDate).toLocaleDateString()}
                  </span>
                )}
              </div>
            </div>
            <div className="text-sm text-gray-600">{x.notes}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
const RecordTypes = [
  { key: 0, label: "Select Record Type", disabled: true },
  { key: 1, label: "Fix" },
  { key: 2, label: "Snap" },
  { key: 3, label: "FVRCP" },
  { key: 4, label: "Rabies" },
  { key: 5, label: "History" },
  { key: 6, label: "Weight" },
];

function RecordTypeFromId(id) {
  switch (id) {
    case 0:
      return "Unknown";
    case 1:
      return "Fix";
    case 2:
      return "Snap";
    case 3:
      return "FVRCP";
    case 4:
      return "Rabies";
    case 5:
      return "History";
    case 6:
      return "Weight";
    default:
      return "";
  }
}

export default MedicalRecords;
